module.exports = __webpack_public_path__ + "img/engineering.9e216b3a.svg";